import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';

const getUserPermissions = (state: IGlobalReduxStore) => state.auth.permissions;

export const isMultiLocationTieringFeatureEnabledSelector = (communityId: number) =>
  createSelector(getUserPermissions, (userPermissions) => {
    if (userPermissions?.MULTI_LOCATION_TIERING?.access)
      return (
        userPermissions?.MULTI_LOCATION_TIERING?.access?.includes('read') &&
        !!userPermissions.MULTI_LOCATION_TIERING.communities &&
        !!userPermissions.MULTI_LOCATION_TIERING.communities[communityId] &&
        !!userPermissions.MULTI_LOCATION_TIERING.communities[communityId]?.includes('read')
      );
    else return false;
  });
